import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { TranslatePipe } from '@ngx-translate/core';
import { IConfirmationDialogData } from './../../interfaces/IConfirmationDialogData';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, TranslatePipe],
})
export class ConfirmationDialogComponent {
  protected confirmationDialogData = inject<IConfirmationDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);

  protected closeDialog(result: boolean | string): void {
    this.dialogRef.close(result);
  }
}
